import Login from '@/components/Authentication/Login'
import OTP from '@/components/Authentication/OTP'
import DefaultLayout from '@/components/layout/DefaultLayout'
//import LoginButton from '@/components/LoginButton';
import Home from '@/components/pages/Home/Home'
import { FC } from 'react'
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from 'react-router-dom'
import PatientStatus from '../pages/PatientStatus/PatientStatus'
import PatientSurvey from '../pages/PatientSurvey'
import PoaList from '../pages/PoaList'
import PoaSurvey from '../pages/PoaSurvey'
import TriageList from '../pages/TriageList'

interface ContentProps {
    contactInfo: string
    onOtpRequested: (contactInfo: string) => void
    onLoginSuccess: (accessToken: string, refreshToken: string) => void
}

const Content: FC<ContentProps> = ({
    contactInfo,
    onOtpRequested,
    onLoginSuccess,
}) => {
    //const location = window.location;
    const router = createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route
                    path="/login"
                    element={<Login onOtpRequested={onOtpRequested} />}
                />
                <Route
                    path="/otp"
                    element={
                        <OTP
                            contactInfo={contactInfo}
                            onLoginSuccess={onLoginSuccess}
                        />
                    }
                />
                <Route path="/home" element={<Home />} />
                <Route path="/patient-status" element={<PatientStatus />} />
                <Route path="/" element={<DefaultLayout />}>
                    <Route index element={<Home />} />
                    <Route path="triageList" element={<TriageList />} />
                    <Route path="poaList" element={<PoaList />} />
                    <Route path="patient" element={<PatientSurvey />} />
                    <Route
                        path="poa/:id?/:questionnaireResponseStatusId?/:questionnaireResponseInformaitionPackId?/:questionnaireResponseId?/:questionnaireId?/:waitingListRecordId?"
                        element={<PoaSurvey />}
                    />
                </Route>
            </>
        )
    )

    // return <RouterProvider router={router} />;
    return (
        <>
            {/* {location.pathname === '/poa' && (
        <div style={{ textAlign: 'center', margin: '20px' }}>
          <LoginButton />
        </div>
      )} */}
            <RouterProvider router={router} />
        </>
    )
}

export default Content
